import apiService from './apiService';

class UserService {
  async getUsers(skip = 0, limit = 500, search = '') {
    try {
      let endpoint = `/api/v1/users/?skip=${skip}&limit=${limit}`;
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch users:', error);
      throw error;
    }
  }
  
  async getAllUsers() {
    try {
      
      const endpoint = '/api/v1/users/?skip=0&limit=2000';
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch all users:', error);
      throw error;
    }
  }
  
  async getUserById(id) {
    try {
      const endpoint = `/api/v1/users/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to fetch user with ID ${id}:`, error);
      throw error;
    }
  }
  
  async createUser(userData) {
    try {
      const endpoint = '/api/v1/users/unified/';
      const response = await apiService.post(endpoint, userData);
      return response;
    } catch (error) {
      console.error('Failed to create user:', error);
      throw error;
    }
  }
  
  async updateUser(id, userData) {
    try {
      const endpoint = `/api/v1/users/${id}`;
      const response = await apiService.put(endpoint, userData);
      return response;
    } catch (error) {
      console.error(`Failed to update user with ID ${id}:`, error);
      throw error;
    }
  }
  
  async deleteUser(id) {
    try {
      const endpoint = `/api/v1/users/${id}`;
      const response = await apiService.delete(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to delete user with ID ${id}:`, error);
      throw error;
    }
  }

  async getDashboardStatistics() {
    try {
      const endpoint = '/api/v1/users/dashboard/statistics';
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new UserService();